import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, List, ListItem, Typography } from '@mui/material';
import React from 'react';

interface AboutSectionProps {
  bio: string;
  questions?: string[];
  sitterName: string;
  isOwnProfile?: boolean;
}

const AboutSection: React.FC<AboutSectionProps> = ({
  bio,
  questions,
  sitterName,
  isOwnProfile = false,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: 2,
        p: 3,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        mb: 3,
      }}
    >
      {/* About Section */}
      <Box sx={{ mb: 4 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            About {sitterName}
          </Typography>
          {isOwnProfile && (
            <IconButton size="small">
              <EditIcon fontSize="small" />
            </IconButton>
          )}
        </Box>

        <Typography
          variant="body1"
          sx={{
            color: '#333',
            lineHeight: 1.8,
            whiteSpace: 'pre-line',
          }}
        >
          {bio}
        </Typography>
      </Box>

      {/* Questions Section */}
      {questions && questions.length > 0 && (
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#333' }}>
            What Jose would like to know about your pet
          </Typography>

          <List sx={{ pl: 2 }}>
            {questions.map((question, index) => (
              <ListItem
                key={index}
                sx={{
                  display: 'list-item',
                  listStyleType: 'disc',
                  pl: 0,
                  py: 0.5,
                }}
              >
                <Typography variant="body2" sx={{ color: '#5A5A5A' }}>
                  {question}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default AboutSection;
